var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZkdigimaxlogoNew14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 189.215,
    height: 26.001,
    viewBox: "0 0 189.215 26.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ZKDIGIMAX_LOGO_-_NEW_-_1",
    "data-name": "ZKDIGIMAX LOGO - NEW - 1",
    transform: "translate(3924 16592)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4292",
    "data-name": "Path 4292",
    d: "M3.068,0H45.175a3.068,3.068,0,0,1,3.068,3.068V22.933A3.068,3.068,0,0,1,45.175,26H3.068A3.068,3.068,0,0,1,0,22.933V3.068A3.068,3.068,0,0,1,3.068,0Z",
    transform: "translate(-3924 -16592)",
    fill: "#78bc27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4271",
    "data-name": "Path 4271",
    d: "M997.272,350.615l-10.841,8.009,5.337,12.408-5.816.009-3.62-9.345-4.282,3.352-1.355,5.986-23.956.012.659-3.812,13.944-12.986H957.054l.677-3.634,16.627,0L973.645,354l-14.636,13.427,13.962-.021L976.8,350.61l4.792.005-2.132,8.8,11.163-8.8Z",
    transform: "translate(-4874.899 -16939.852)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4291",
    "data-name": "Path 4291",
    d: "M115.891,20.324H110.6l-1.841-4.065H98.864l-1.841,4.065H91.731L100.6,0h6.425l8.868,20.325,8.283-10.4L116.275,0h6.289l4.755,5.972L132.074,0h6.289l-7.9,9.922,8.283,10.4h-6.289l-5.139-6.454-5.139,6.454h-6.289Zm-15.033-8.59h5.906l-2.953-6.826Zm-10.815,8.59H84.675V7.8L80,14.5h-3.6L71.713,7.8V20.324H66.344V0h5.522l6.366,9.2L84.6,0h5.446V20.324h0Zm-32.443,0V0h5.369V20.324Zm-20.708,0A3.985,3.985,0,0,1,32.9,16.336V3.987A3.985,3.985,0,0,1,36.892,0h16.8V4.524H39.116a.768.768,0,0,0-.767.767v9.741a.768.768,0,0,0,.767.767H48.4a.768.768,0,0,0,.767-.767V12.424H43.1V7.9h11.5v8.437a3.985,3.985,0,0,1-3.988,3.988Zm-12.5,0V0h5.369V20.324ZM0,20.324V0H15.263a6.106,6.106,0,0,1,3.431,1.048,6.154,6.154,0,0,1,2.223,2.7A6.1,6.1,0,0,1,21.4,6.135v8.053a6.106,6.106,0,0,1-1.048,3.431,6.154,6.154,0,0,1-2.7,2.223,6.1,6.1,0,0,1-2.388.482ZM5.369,15.8h7.67a2.918,2.918,0,0,0,2.915-2.915V7.439a2.918,2.918,0,0,0-2.915-2.915H5.369Z",
    transform: "translate(-3873.532 -16588.854)",
    fill: "#1487ca"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZkdigimaxlogoNew14);
export default __webpack_public_path__ + "static/media/ZKDIGIMAX LOGO - NEW - 1 (4).64004ab59ccf9b1f380cedb22ab602ed.svg";
export { ForwardRef as ReactComponent };